export default function HowItWorksSection() {
  const steps = [
    {
      number: '01',
      title: 'Download WingmanFix',
      description: 'Install the app and connect your aviation headset.',
      icon: 'ri-download-cloud-line'
    },
    {
      number: '02',
      title: 'Turn on Bluetooth',
      description: 'WingmanFix listens to cockpit audio, ATC calls, and flight data.',
      icon: 'ri-bluetooth-line'
    },
    {
      number: '03',
      title: 'Fly normally',
      description: 'After landing, you get a full flight review with scores, insights, and coaching notes.',
      icon: 'ri-flight-takeoff-line'
    }
  ];

  return (
    <section id="how-it-works" className="py-16 sm:py-20 lg:py-24 bg-gradient-to-b from-[#0D1B2E] to-[#0A1628]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16 lg:mb-20">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 sm:mb-6">Three steps to a smarter cockpit.</h2>
        </div>

        {/* Steps Grid */}
        <div className="grid md:grid-cols-3 gap-6 sm:gap-8 mb-12 sm:mb-16">
          {steps.map((step, idx) => (
            <div 
              key={idx}
              className="bg-[#0F1F35] rounded-2xl p-6 sm:p-8 border border-gray-700 hover:border-[#00FFD1] transition-all hover:-translate-y-2 group"
            >
              <div className="relative w-20 h-20 sm:w-24 sm:h-24 mx-auto mb-4 sm:mb-6">
                <div className="absolute inset-0 bg-[#00A3E0]/20 rounded-full flex items-center justify-center">
                  <span className="text-3xl sm:text-4xl font-bold text-[#00A3E0]">{step.number}</span>
                </div>
              </div>
              
              <div className="w-12 h-12 sm:w-16 sm:h-16 flex items-center justify-center mx-auto mb-4 sm:mb-6">
                <i className={`${step.icon} text-4xl sm:text-5xl text-[#00FFD1] group-hover:scale-110 transition-transform`}></i>
              </div>

              <h3 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4 text-center">{step.title}</h3>
              <p className="text-sm sm:text-base text-gray-300 leading-relaxed text-center">{step.description}</p>
            </div>
          ))}
        </div>

        {/* Supporting Visual */}
        <div className="max-w-4xl mx-auto relative rounded-2xl sm:rounded-3xl overflow-hidden border-2 border-[#00FFD1]/30 shadow-2xl">
          <img 
            src="https://public.readdy.ai/ai/img_res/102fc23cdd10798a7ebf7d012c3112c4.jpg"
            alt="Pilot with Bluetooth headset"
            className="w-full h-56 sm:h-72 lg:h-96 object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0A1628] via-[#0A1628]/60 to-transparent"></div>
          <div className="absolute inset-0 flex items-center justify-center px-4">
            <div className="text-center">
              <p className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white tracking-wider">Connect. Fly. Review.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}